import { logErrorToSentry } from "@litres/utils";

import type { TVarioqubRequestArgs, IVarioqubResponse } from "./varioqub.types";
import { varioqubResponseValidator } from "./varioqubResponseValidator";
import { rtkqApi } from "../api/rtkqApi";

const fallbackResponse = {
  i: "",
  experiments: "",
  flags: [],
  testids: [],
};

export const varioqubApi = rtkqApi.injectEndpoints({
  endpoints: build => ({
    getVarioqubData: build.query<IVarioqubResponse, TVarioqubRequestArgs>({
      query({ client_id, url, i, userAgent }) {
        return {
          url: "https://uaas.yandex.ru/v1/exps",
          method: "GET",
          params: {
            client_id: `metrika.${client_id}`,
            url,
            i,
          },
          headers: {
            Referer: url,
            "User-Agent": userAgent,
          },
        };
      },
      transformResponse: (response: IVarioqubResponse) => {
        /* мы не можем полностью доверять Яндексу, т.к. они могут изменить контракт не оповестив об этом нас */
        try {
          return varioqubResponseValidator(response);
        } catch (e) {
          logErrorToSentry((e as Error).message, {
            tags: {
              type: "critical",
            },
            logLevel: "fatal",
          });

          return fallbackResponse;
        }
      },
    }),
  }),
});
